import { render, staticRenderFns } from "./product-attrs.vue?vue&type=template&id=bba02992&"
import script from "./product-attrs.vue?vue&type=script&lang=js&"
export * from "./product-attrs.vue?vue&type=script&lang=js&"
import style0 from "./product-attrs.vue?vue&type=style&index=0&id=bba02992&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports